import React from 'react';
import PropTypes from 'prop-types';
import { Separator, Title } from '@common/components';
import cx from 'classnames';
import dashboardSectionClasses from './DashboardSection.module.scss';

export default function DashboardSection({
  className,
  title,
  withoutSeparator = false,
  children,
}) {
  const cn = cx(dashboardSectionClasses.dashboardContainer, className);

  return (
    <div className={cn}>
      <Title type="h1" color="primary">
        {title}
      </Title>
      {withoutSeparator ? null : <Separator />}
      {children}
    </div>
  );
}

DashboardSection.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  withoutSeparator: PropTypes.bool,
  children: PropTypes.node,
};
